import { render, staticRenderFns } from "./SFATracker.vue?vue&type=template&id=5a79ca8a&scoped=true&"
import script from "./SFATracker.vue?vue&type=script&lang=js&"
export * from "./SFATracker.vue?vue&type=script&lang=js&"
import style0 from "./SFATracker.vue?vue&type=style&index=0&id=5a79ca8a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a79ca8a",
  null
  
)

export default component.exports